import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { PureComponent } from 'react';
import './guide.less';
export default class Guide extends PureComponent {
    render() {
        const rootClass = classnames({
            guide: true,
        }, this.props.className);
        return _jsx("div", Object.assign({ className: rootClass }, { children: this.props.children }));
    }
}
